module.exports = __webpack_public_path__ + "img/selection_help00.a1fb65ee.gif";